import { useState, useEffect, useRef } from "react";

import "./Homepage.css";
import "./Loader.jsx";
import icons from "./icons.js";
import img1 from "../img/profile_1.png";
import img2 from "../img/profile_4.png";
import img3 from "../img/profile_2.png";
import img4 from "../img/profile_3.png";
import { useTranslation } from "react-i18next";
// ── Discover Matches profiles ──
import FBH1 from "../img/FBHimg1.png";
import FBH2 from "../img/FBHimg2.png";
import FBH3 from "../img/FBHimg3.png";
import { Link, Links, useNavigate } from "react-router-dom";
import Loader from "./Loader.jsx";

/*
  HeroSection.jsx
  ---------------
  Props:
    bgImage  — URL of the hero background photo (the couple image)
  
  Usage:
    import HeroSection from "./HeroSection";
    <HeroSection bgImage="/path/to/couple.jpg" />
*/



export default function Homepage({ bgImage }) {
  const { t, i18n } = useTranslation();
  const CARDS = [
  {
    key: "emotion",
    title: t("card1_title"),
    body: t("card1_body"),
  },
  {
    key: "verified",
    title: t("card2_title"),
    body: t("card2_body"),
  },
  {
    key: "family",
    title: t("card3_title"),
    body: t("card3_body"),
  },
  {
    key: "privacy",
    title: t("card4_title"),
    body: t("card4_body"),
  },
];

const STEPS = [
  {
    key: "01",
    label: "01",
    title: t("step1_title"),
    body: t("step1_body"),
    isHeart: false,
  },
  {
    key: "02",
    label: "02",
    title: t("step2_title"),
    body: t("step2_body"),
    isHeart: false,
  },
  {
    key: "03",
    label: "03",
    title: t("step3_title"),
    body: t("step3_body"),
    isHeart: false,
  },
  {
    key: "04",
    label: null,
    title: t("step4_title"),
    body: t("step4_body"),
    isHeart: true,
  },
];

// section 5

const stories = [
  {
    image: FBH1,
    quote:
      t("story1_quote"),
    names: t("story1_names"),
    date: t("story1_date"),
  },
  {
    image: FBH2,
    quote:
      t("story2_quote"),
    names: t("story2_names"),
    date: t("story2_date"),
  },
  {
    image: FBH3,
    quote:
      t("story3_quote"),
    names: t("story3_names"),
    date: t("story3_date"),
  },
];

// section 6

const profiles = [
  {
    image: img1,
    name: t("priya_s"),
    age: 28,
    profession: t("architect"),
    city: t("mumbai"),
  },
  {
    image: img2,
    name: t("sanjai_g"),
    age: 31,
    profession: t("entrepreneur"),
    city: t("delhi"),
  },
  {
    image: img3,
    name: t("kavya_s"),
    age: 29,
    profession: t("doctor"),
    city: t("bangalore"),
  },
  {
    image: img4,
    name: t("anandh_v"),
    age: 30,
    profession: t("finance_lead"),
    city: t("pune"),
  },
];
  const [active, setActive] = useState(0);
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          contentRef.current?.classList.add("cta-section__content--visible");
        }
      },
      { threshold: 0.25 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // check auth
  const checkAuth = () => {
    const token = localStorage.getItem("token");
    return !!token;
  };
  return (
    <>
    <div data-lang={i18n.language}> 
      {/* <Loader /> */}
      <section className="niran-hero">
        {/* Background image */}
        <div className="niran-hero__bg" />

        {/* Foreground card */}
        <div className="niran-hero__content">
          <div className="niran-hero__card">
            <h1 className="niran-hero__heading">
              {t("hero_title_1")}
              <br />
              {t("hero_title_2")}
            </h1>

            <div className="niran-hero__divider" />

            <p className="niran-hero__body">
              {t("hero_desc_1")}
              <br /> {t("hero_desc_2")}
            </p>

            <div className="niran-hero__actions">
              <button
                className="niran-hero__btn-primary"
                onClick={() =>
                  checkAuth() ? navigate("/dashboard") : navigate("/register")
                }
              >
                {t("create_profile")}
              </button>
              <button
                className="niran-hero__btn-secondary"
                onClick={() => navigate("/matches")}
              >
                {t("explore_matches")}
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="about-section">
        <div className="about-section__inner">
          {/* ── Left column: image + decorative brackets + badge ── */}
          <div className="about-section__image-block">
            <div className="about-section__corner-tl" />
            <div className="about-section__corner-br" />

            <div
              className="about-section__img"
              role="img"
              aria-label="Wedding rings symbolising a meaningful beginning"
            />

            <div className="about-section__badge">
              <p className="about-section__badge-number">48,000+</p>
              <p className="about-section__badge-label">{t("couples_married")}</p>
            </div>
          </div>

          {/* ── Right column: heading + body ── */}
          <div className="about-section__text-block">
            <h2 className="about-section__heading">
              {t("about_title_1")} 
              <br />{t("about_title_2")}
            </h2>

            <div className="about-section__divider" />
            <h3 className="about_h2">
              {t("about_subtitle")}
            </h3>

            <p className="about-section__body">
              {t("about_desc")}
            </p>
          </div>
        </div>
      </section>
      <section className="why-section">
        <div className="why-section__corner" />

        {/* Header */}
        <div className="why-section__header">
          <h2 className="why-section__title">{t("why_title")}</h2>
          <p className="why-section__subtitle">
            {t("why_desc")}
          </p>
        </div>

        {/* Cards */}
        <div className="why-section__grid">
          {CARDS.map((card) => (
            <div className="why-section__card" key={card.key}>
              <div className="why-section__icon-wrap">
                {icons[card.key] && (
                  <img
                    src={icons[card.key]}
                    alt={card.title}
                    className="why-section__icon"
                  />
                )}
              </div>
              <h3 className="why-section__card-title">{card.title}</h3>
              <p className="why-section__card-body">{card.body}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="how-section">
        <div className="how-section__header">
          <h2 className="how-section__title">{t("journey_title")}</h2>
          <p className="how-section__subtitle">
            {t("journey_desc")}
          </p>
        </div>

        <div className="how-section__timeline">
          {STEPS.map((step) => (
            <div className="how-section__step" key={step.key}>
              <div
                className={`how-section__circle ${step.isHeart ? "how-section__circle--heart" : ""}`}
              >
                {step.isHeart ? (
                  <svg className="how-section__heart" viewBox="0 0 24 24">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                  </svg>
                ) : (
                  <span className="how-section__circle-label">
                    {step.label}
                  </span>
                )}
              </div>
              <div>
                <h3 className="how-section__step-title">{step.title}</h3>
                <p className="how-section__step-body">{step.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* section 5 */}

      <section className="stories-section">
        <div className="stories-section__header">
          <h2 className="stories-section__title">
            {t("stories_title")}
          </h2>
          <p className="stories-section__subtitle">
            {t("stories_desc")}
          </p>
        </div>

        <div className="stories-section__grid">
          {stories.map((story, i) => (
            <div className="stories-section__card" key={i}>
              <div
                className="stories-section__photo"
                style={
                  story.image ? { backgroundImage: `url(${story.image})` } : {}
                }
                role="img"
                aria-label={story.names}
              />
              <div className="stories-section__card-body">
                <div className="stories-section__quote-icon">
                  &#x201C;&#x201C;
                </div>
                <p className="stories-section__quote-text">"{story.quote}"</p>
                <p className="stories-section__names">{story.names}</p>
                <p className="stories-section__date">{story.date}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="stories-section__dots">
          {stories.map((_, i) => (
            <button
              key={i}
              className={`stories-section__dot ${i === active ? "stories-section__dot--active" : ""}`}
              onClick={() => setActive(i)}
              aria-label={`Story ${i + 1}`}
            />
          ))}
        </div>
      </section>
      {/* section6 */}
      <section className="matches-section">
        <div className="matches-section__header">
          <h2 className="matches-section__title">
            {t("matches_title")}{" "}
          </h2>
          <p className="matches-section__subtitle">
            {t("matches_desc")}
          </p>
        </div>

        <div className="matches-section__row">
          <div className="matches-section__grid">
            {profiles.map((profile, i) => (
              <div className="matches-section__card" key={i}>
                <div className="matches-section__photo-wrap">
                  <div
                    className="matches-section__photo"
                    style={
                      profile.image
                        ? { backgroundImage: `url(${profile.image})` }
                        : {}
                    }
                    role="img"
                    aria-label={profile.name}
                  />
                </div>

                <div className="matches-section__info">
                  <p className="matches-section__name">{profile.name}</p>
                  <span className="matches-section__verified">{t("verified")}</span>
                </div>

                <div className="matches-section__tags">
                  <span className="matches-section__tag">{profile.age}</span>
                  <span className="matches-section__tag">
                    {profile.profession}
                  </span>
                  <span className="matches-section__tag">{profile.city}</span>
                </div>
              </div>
            ))}
          </div>

          {/* View More arrow */}
          <div className="matches-section__view-more">
            <Link
              to="/matches"
              className="matches-section__arrow-btn"
              aria-label="View more profiles"
            >
              <svg viewBox="0 0 24 24">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </Link>
            <span className="matches-section__view-label">{t("view_more")}</span>
          </div>
        </div>
      </section>
      {/* section7 */}
      <section className="cta-section" ref={sectionRef}>
        <div className="cta-section__bg" />

        <div className="cta-section__content" ref={contentRef}>
          <h2 className="cta-section__title">
            {t("cta_title")}
          </h2>
          <p className="cta-section__body">
            {t("cta_desc_1")}
            <br />
            {t("cta_desc_2")}
          </p>
          <button
            className="cta-section__btn"
            onClick={() =>
              checkAuth() ? navigate("/pricing") : navigate("/register")
            }
          >
            {t("join_now")}
          </button>
        </div>
      </section>
      </div>
    </>
  );
}
